
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"64","height":"64","fill":"#400F3F","rx":"8.258"}}),_c('path',{attrs:{"fill":"#FF4702","fill-rule":"nonzero","d":"M28.243 29.832l6.893-11.937A14.893 14.893 0 0032 17.548a14.429 14.429 0 00-9.133 3.252l5.289 9.177.087-.145zm17.544-2.167a14.488 14.488 0 00-8.671-9.163l-5.29 9.163h13.96zm.376 1.445H35.338l.42.722 6.878 11.923A14.322 14.322 0 0046.452 32c0-.997-.102-1.951-.29-2.89zM27 32l-5.636-9.755c-2.356 2.573-3.816 5.983-3.816 9.755 0 .997.102 1.951.29 2.89h10.824L27 32zm-8.787 4.335a14.488 14.488 0 008.671 9.163l5.29-9.163h-13.96zm16.287 0l-5.636 9.77a14.88 14.88 0 003.136.347c3.468 0 6.648-1.229 9.133-3.252l-5.289-9.177-1.344 2.312z"}})])])
          )
        }
      }
    